import React, { useEffect, useState } from 'react';
import { FiX } from 'react-icons/fi';

const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      setTimeout(() => setIsVisible(false), 200);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
      onClose();
    }, 200);
  };

  if (!isVisible) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl'
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className={`modal-backdrop fixed inset-0 bg-gray-900 transition-all duration-300 ease-out ${
            isAnimating ? 'bg-opacity-50 backdrop-blur-sm' : 'bg-opacity-0'
          }`}
          onClick={handleClose}
        />

        {/* Center modal */}
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>

        <div className={`inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all duration-300 ease-out sm:my-8 sm:align-middle w-full ${
          isAnimating 
            ? 'translate-y-0 opacity-100 scale-100' 
            : 'translate-y-4 opacity-0 scale-95'
        } ${sizeClasses[size]}`}>
          {/* Header */}
          <div className="bg-white px-6 pt-6 pb-4 border-b border-gray-100">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-xl leading-6 font-bold text-gray-900">
                {title}
              </h3>
              <button
                onClick={handleClose}
                className="bg-gray-100 rounded-lg p-2 text-gray-400 hover:text-brand-primary hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-brand-primary transition-all duration-200 btn-animate"
              >
                <FiX className="h-5 w-5" />
              </button>
            </div>
          </div>
            
          {/* Content */}
          <div className="px-6 py-4">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;